import { createContext, useContext } from 'react';
import type {
  AuthenticatedUser,
  AuthSession,
  AuthStatus,
  ForgotPasswordInput,
  LoginInput,
  RegisterInput,
  RegistrationResult,
  ResendVerificationCodeInput,
  ResetPasswordInput,
  VerifyEmailInput,
} from '@emazy/shared-types';

export type AuthContextValue = {
  status: AuthStatus;
  session: AuthSession | null;
  user: AuthenticatedUser | null;
  isAuthenticated: boolean;
  login(input: LoginInput): Promise<AuthSession>;
  register(input: RegisterInput): Promise<RegistrationResult>;
  verifyEmail(input: VerifyEmailInput): Promise<void>;
  resendVerificationCode(input: ResendVerificationCodeInput): Promise<void>;
  forgotPassword(input: ForgotPasswordInput): Promise<void>;
  resetPassword(input: ResetPasswordInput): Promise<void>;
  logout(): Promise<void>;
  refreshSession(): Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider.');
  return context;
}
